import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Отказано службой безопасности", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Обратитесь в службу безопасности", -1)
const _hoisted_8 = {
  key: 1,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "Физ. лицо не прошел проверку службы безопасности", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Обратитесь в службу безопасности", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_13 = {
  key: 0,
  class: "grid grid-cols-1 gap-4"
}
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_add_car_modal = _resolveComponent("add-car-modal")!
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: "Добавление водителя",
    loading: _ctx.loading,
    overflow: true,
    "confirm-disabled": !_ctx.sb_state_iin.is_success,
    onSubmit: _ctx.emitCreate,
    onCancel: _ctx.emitCancel
  }, {
    default: _withCtx(() => [
      (_ctx.car_state.is_opened)
        ? (_openBlock(), _createBlock(_component_add_car_modal, {
            key: 0,
            loading: _ctx.car_state.is_loading,
            onCreate: _ctx.createCar,
            onCancel: _ctx.toggleCar
          }, null, 8, ["loading", "onCreate", "onCancel"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_new_input, {
              placeholder: "ИИН",
              class: "w-full",
              value: _ctx.state.iin,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.iin) = $event)),
              "is-invalid": _ctx.state_form$.iin.$error || _ctx.iin_form$.iin.$error,
              "validation-errors": _ctx.state_form$.iin.$errors || _ctx.iin_form$.iin.$errors,
              disabled: _ctx.sb_state_iin.is_success
            }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
            _createVNode(_component_new_button, {
              class: "flex items-center text primary small ml-2 py-3",
              loading: _ctx.sb_state_iin.is_loading,
              onClick: _ctx.checkSbStatusIIN
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createTextVNode(" Проверить ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ]),
          (_ctx.isRejectedIIN)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("p", null, [
                  _hoisted_6,
                  _createTextVNode(" (" + _toDisplayString(_ctx.sb_state_iin.reject_comment) + ") ", 1)
                ]),
                _hoisted_7
              ]))
            : _createCommentVNode("", true),
          (_ctx.isNotCheckedIIN)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
            : _createCommentVNode("", true),
          (_ctx.sb_state_iin.backend_error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.sb_state_iin.backend_error), 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.sb_state_iin.is_success)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_new_select, {
                value: _ctx.state.dispatcherSectorId,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.dispatcherSectorId) = $event)),
                placeholder: "Сектор диспетчера",
                "is-invalid": _ctx.state_form$.dispatcherSectorId.$error,
                "validation-errors": _ctx.state_form$.dispatcherSectorId.$errors,
                loading: _ctx.data_state.dispatchers_sectors.is_loading,
                options: _ctx.data_state.dispatchers_sectors.list,
                failed: _ctx.data_state.dispatchers_sectors.is_failed,
                "error-text": "При получении списка секторов диспетчера произошла ошибка",
                "search-by": "name",
                "select-by": "id",
                label: "name",
                onRefresh: _ctx.loadDispatchersSectors
              }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onRefresh"]),
              _createVNode(_component_new_select, {
                value: _ctx.state.typeIds,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.typeIds) = $event)),
                placeholder: "Тип курьера",
                "is-invalid": _ctx.state_form$.typeIds.$error,
                "validation-errors": _ctx.state_form$.typeIds.$errors,
                loading: _ctx.data_state.types.is_loading,
                options: _ctx.data_state.types.list,
                failed: _ctx.data_state.types.is_failed,
                searchable: false,
                multiselect: "",
                "error-text": "При получении списка типов курьера произошла ошибка",
                "select-by": "id",
                label: "title",
                onRefresh: _ctx.loadDispatchersSectors
              }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onRefresh"]),
              _createVNode(_component_new_select, {
                value: _ctx.state.companyId,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.companyId) = $event)),
                placeholder: "Компания",
                "is-invalid": _ctx.state_form$.companyId.$error,
                "validation-errors": _ctx.state_form$.companyId.$errors,
                loading: _ctx.data_state.companies.is_loading,
                options: _ctx.data_state.companies.list,
                failed: _ctx.data_state.companies.is_failed,
                "error-text": "При получении списка компаний произошла ошибка",
                "search-by": "name",
                "select-by": "id",
                label: "name",
                "infinite-scroll": "",
                onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadCarriers(_ctx.data_state.companies.pagination.current_page))),
                onLoadmore: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadMoreCarriers(_ctx.data_state.companies.pagination.current_page + 1))),
                onSearch: _ctx.searchCarriers,
                onOptionBySearch: _ctx.unshiftFindedCarrier
              }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
              _createVNode(_component_new_input, {
                placeholder: "ФИО",
                value: _ctx.state.fullName,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.fullName) = $event)),
                "is-invalid": _ctx.state_form$.fullName.$error,
                "validation-errors": _ctx.state_form$.fullName.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"]),
              _createVNode(_component_new_input, {
                placeholder: "Номер телефона",
                value: _ctx.state.phoneNumber,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.phoneNumber) = $event)),
                "is-invalid": _ctx.state_form$.phoneNumber.$error,
                "validation-errors": _ctx.state_form$.phoneNumber.$errors,
                maska: _ctx.PHONE_NUMBER_MASK
              }, null, 8, ["value", "is-invalid", "validation-errors", "maska"]),
              _createVNode(_component_new_select, {
                value: _ctx.state.paymentRateType,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.paymentRateType) = $event)),
                placeholder: "Выберите тип оплаты",
                name: "Тип оплаты",
                options: _ctx.CourierPaymentTypes,
                disabled: ""
              }, null, 8, ["value", "options"]),
              _createVNode(_component_new_input, {
                placeholder: "Номер удостоверения личности",
                "is-invalid": _ctx.state_form$.courierLicenses.identifyCardNumber.$error,
                "validation-errors": _ctx.state_form$.courierLicenses.identifyCardNumber.$errors,
                value: _ctx.state.courierLicenses.identifyCardNumber,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.courierLicenses.identifyCardNumber) = $event))
              }, null, 8, ["is-invalid", "validation-errors", "value"]),
              _createVNode(_component_new_input, {
                type: "date",
                placeholder: "Дата выдачи удостоверения личности",
                "is-invalid": _ctx.state_form$.courierLicenses.identifyCardIssueDate.$error,
                "validation-errors": _ctx.state_form$.courierLicenses.identifyCardIssueDate.$errors,
                value: _ctx.state.courierLicenses.identifyCardIssueDate,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.courierLicenses.identifyCardIssueDate) = $event))
              }, null, 8, ["is-invalid", "validation-errors", "value"]),
              _createVNode(_component_new_input, {
                placeholder: "Номер водительского удостоверения",
                "is-invalid": _ctx.state_form$.courierLicenses.driverLicenseNumber.$error,
                "validation-errors": _ctx.state_form$.courierLicenses.driverLicenseNumber.$errors,
                value: _ctx.state.courierLicenses.driverLicenseNumber,
                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.courierLicenses.driverLicenseNumber) = $event))
              }, null, 8, ["is-invalid", "validation-errors", "value"]),
              _createVNode(_component_new_input, {
                type: "date",
                placeholder: "Дата выдачи водительского удостоверения",
                "is-invalid": _ctx.state_form$.courierLicenses.driverLicenseIssueDate.$error,
                "validation-errors": _ctx.state_form$.courierLicenses.driverLicenseIssueDate.$errors,
                value: _ctx.state.courierLicenses.driverLicenseIssueDate,
                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.courierLicenses.driverLicenseIssueDate) = $event))
              }, null, 8, ["is-invalid", "validation-errors", "value"]),
              _createVNode(_component_file_reader, {
                accept: "image/*",
                placeholder: "Удостоверение",
                multiple: "",
                disabled: _ctx.loading,
                value: _ctx.state.certificate,
                "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.certificate) = $event))
              }, null, 8, ["disabled", "value"]),
              _createVNode(_component_file_reader, {
                accept: "image/*",
                placeholder: "Водительские права",
                multiple: "",
                disabled: _ctx.loading,
                value: _ctx.state.driverLicenses,
                "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.driverLicenses) = $event))
              }, null, 8, ["disabled", "value"]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_new_select, {
                  class: "w-full mr-2",
                  placeholder: "Автомобиль",
                  loading: _ctx.data_state.cars.is_loading,
                  failed: _ctx.data_state.cars.is_failed,
                  "error-text": "При получении списка автомобилей произошла ошибка",
                  options: _ctx.data_state.cars.list,
                  value: _ctx.state.carId,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.carId) = $event)),
                  "is-invalid": _ctx.state_form$.carId.$error,
                  "validation-errors": _ctx.state_form$.carId.$errors,
                  "search-without-refresh": "",
                  "infinite-scroll": "",
                  onRefresh: _ctx.loadCars,
                  onLoadmore: _cache[16] || (_cache[16] = ($event: any) => (_ctx.loadMoreCars(_ctx.data_state.cars.pagination.current_page + 1))),
                  onSearch: _ctx.searchCars,
                  onOptionBySearch: _ctx.unshiftFindedCar
                }, {
                  "selected-option": _withCtx(({ option }) => [
                    _createTextVNode(_toDisplayString(option.model) + ", " + _toDisplayString(option.number), 1)
                  ]),
                  option: _withCtx(({ option }) => [
                    _createTextVNode(_toDisplayString(option.model) + ", " + _toDisplayString(option.number), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "failed", "options", "value", "is-invalid", "validation-errors", "onRefresh", "onSearch", "onOptionBySearch"]),
                _createVNode(_component_new_button, {
                  class: "NewButton--large primary",
                  onClick: _ctx.toggleCar
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["loading", "confirm-disabled", "onSubmit", "onCancel"]))
}